var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Calendar',{attrs:{"events":_vm.slots,"type":_vm.type,"hoverEffect":false},on:{"event-selected":_vm.selectEvent,"update-range":_vm.updateRange}})
}
var staticRenderFns = []

export { render, staticRenderFns }